module.exports = __webpack_public_path__ + "static/media/United_logo_white.b116d85d.png";